import { styled, Typography, type TypographyProps } from "@mui/material";
import React, { type FC } from "react";

type Props = {
  fields?: Array<string>;
} & TypographyProps;

const StyledRequiredField = styled(Typography)`
  font-size: 0.8rem;
  text-align: start;
`;

export const RequiredFieldsIndicator: FC<Props> = ({ fields, ...typographyProps }) => {
  let text;
  if (!fields) {
    text = "Tous les champs sont obligatoires";
  } else if (fields?.length === 1) {
    text = `Le champ ${fields[0]} est obligatoire`;
  } else if (fields?.length > 1) {
    text = `Les champs ${fields?.join(", ")} sont obligatoires`;
  }

  return <StyledRequiredField {...typographyProps}>{text}</StyledRequiredField>;
};
